module.exports = __webpack_public_path__ + "img/cooper.1b516c5a.png";